export const jsProjects = [
  {

  id: 1,
  title: "Chat App",
  img:"assets/chattt.jpg",
  URL:"https://github.com/rahul5316/Camera-App",
},

{

  id: 2,
  title: "Camera App",
  img:"assets/camera.jpeg",
  URL:"https://github.com/rahul5316/Real-Time-Chat-App",
}


];



export const javaProjects =[{

  id: 3,
  title: "Fantasy Football Appliction",
  img:"assets/ff.png",
  URL:"https://github.com/rahul5316/FantasyFootball"

}
] 


export const algoProjects = [{

  id: 4,
  title: "Algorithms Manipulation",
  img: "assets/algo.jpeg"
}]

